import { ALMOND_PUBLICATION_SPACES } from "./almondPublicationCatalogV1.mjs";
import { OPEN_LIBRARY_EDITORIAL_SECTIONS } from "./editorialWorkspaceNavigationV1.mjs";

const technical = /\b(?:QA|E2E)\b|runtime|digital editions|publication mirror|тест публикац/i;

export function isEditorialTechnicalSample(material) {
  return !!material && (material.qa_fixture === true || material.e2e_fixture === true ||
    technical.test(String(material.title || "")));
}
export function editorialCardTitle(material) {
  return material?.title || "Без названия";
}
export function openLibraryCategory(material) {
  // Never infer a category from the title: an explicit author decision wins.
  const known = OPEN_LIBRARY_EDITORIAL_SECTIONS.find((s) => s.id === material?.open_library_section);
  return known?.title || "Раздел не указан";
}
export function bookPlacementByMaterial(pages = [], sections = [], subsections = []) {
  const result = new Map();
  const sectionById = new Map(sections.map((s) => [s.id, s]));
  const subsectionById = new Map(subsections.map((s) => [s.id, s]));
  for (const page of pages) {
    if (!page?.editorial_material_id || result.has(page.editorial_material_id)) continue;
    const bookSection = sectionById.get(page.section_id);
    const bookCategory = subsectionById.get(page.subsection_id);
    result.set(page.editorial_material_id, {
      spaceKey: bookSection?.slug || null,
      categoryId: bookCategory?.slug || null,
      categoryTitle: bookCategory?.title || bookSection?.title || "Место не указано",
    });
  }
  return result;
}
export function almondSpaceTitle(spaceKey) {
  return ALMOND_PUBLICATION_SPACES.find((s) => s.key === spaceKey)?.title || "Раздел не указан";
}
export function cardDisplaySection(material, workspaceKey, placement) {
  if (workspaceKey === "open-library") return openLibraryCategory(material);
  if (workspaceKey === "almond") return placement?.categoryTitle || "Раздел не указан";
  return "Раздел не указан";
}
export function isMaterialInAlmondSpace(placement, spaceKey) {
  return !spaceKey || (placement?.spaceKey === spaceKey);
}
export function thumbnailFromEditorialBlocks(blocks = [], material = {}) {
  const direct = material.cover_url || material.cover_image_url || material.cover_image;
  if (typeof direct === "string" && direct) return direct;
  for (const b of blocks) {
    const c = b?.content || {};
    const urls = [c.hero_url, c.recipe?.hero?.url, c.macro?.main_image?.url,
      c.macro_sensory?.main_image?.url, c.portrait_dialogue?.portrait?.url,
      c.historical_editorial?.main_image?.url, c.extra?.historical_editorial?.main_image?.url,
      c.extra?.video_master?.poster?.url, c.images?.[0]?.url,
      c.photos?.[0]?.url, c.media?.[0]?.file_url, c.media?.[0]?.url];
    const url = urls.find((u) => typeof u === "string" && u);
    if (url) return url;
  }
  return "";
}
export function thumbnailMediaIdFromBlocks(blocks = [], material = {}) {
  if (material?.cover_media_id) return material.cover_media_id;
  for (const b of blocks) {
    const c = b?.content || {};
    const id = c.hero_media_id || c.recipe?.hero?.media_id || c.media_ids?.[0];
    if (id) return id;
  }
  return null;
}
